import {
  BUSINESS_RELATIONSHIP_SORTS,
  type BusinessRelationshipSort,
  type PartnerTradeStatus,
} from '@/entities/business-relationship/api/business-relationship.api';
import { PAGE_SIZE_OPTIONS } from '@/shared/constants/pagination';
import {
  parseEnum,
  parsePageSize,
  parsePositiveInt,
  parsePositiveIntList,
  parseString,
} from '@/shared/lib/searchParams';

/**
 * 06 거래처 정보 URL 상태 — 키 이름은 API(RDL-112)와 같다.
 * detailUserId·detailClinicId가 있으면 07-1 상세 패널이 열린다 (새로고침·공유 시 유지).
 * 담당자·제약사 필터는 다중 선택이다.
 */
export interface ClientsSearch {
  keyword?: string;
  userIds?: number[];
  pharmaCompanyIds?: number[];
  /** 없으면 전체(거래 중 + 거래 종료) — 서버 기본값 ALL */
  tradeStatus?: PartnerTradeStatus;
  /** 없으면 USER(담당자순) */
  sort?: BusinessRelationshipSort;
  page?: number;
  /** 보기 개수. 없으면 DEFAULT_VIEW_PAGE_SIZE */
  size?: number;
  detailUserId?: number;
  detailClinicId?: number;
}

export const validateClientsSearch = (
  search: Record<string, unknown>,
): ClientsSearch => ({
  keyword: parseString(search.keyword),
  userIds: parsePositiveIntList(search.userIds),
  pharmaCompanyIds: parsePositiveIntList(search.pharmaCompanyIds),
  // 'ALL'은 기본값이라 URL에 남기지 않는다
  tradeStatus: parseEnum(search.tradeStatus, ['TRADING', 'ENDED']),
  sort: parseEnum(search.sort, BUSINESS_RELATIONSHIP_SORTS),
  page: parsePositiveInt(search.page),
  size: parsePageSize(search.size, PAGE_SIZE_OPTIONS),
  detailUserId: parsePositiveInt(search.detailUserId),
  detailClinicId: parsePositiveInt(search.detailClinicId),
});
